<template>
  <div class="client_detail">
    <van-sticky>
      <van-nav-bar title="客户详情" left-arrow @click-left="goback()" />
    </van-sticky>

    <!-- 客户基本信息 -->
    <div class="detail_list">
      <van-image
        class="m-b15"
        height="70"
        width="70"
        :src="detailData.portrait"
        fit="cover"
        round
      />
      <div class="list_detail">
        <div>{{ detailData.nickname }}</div>
        <div>Tel：{{ detailData.contactNumber }}</div>
        <div>签约日期:{{ detailData.signTime }}</div>
      </div>

      <div class="list_edit" @click="toClientEdit(detailData.id)">
        <van-icon name="edit" />
        <div>编辑</div>
      </div>
    </div>

    <!-- 表单 -->
    <van-form label-width="90" class="detail_form">
      <van-cell-group>
        <div class="lease_title">基础信息</div>

        <van-field
          input-align="right"
          :value="detailData.gender_name"
          label="性别"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.birth"
          label="生日"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.emergencyContactName"
          label="紧急联系人"
          placeholder="请输入"
          readonly
        />

        <van-field
          input-align="right"
          :value="detailData.emergencyContactPhone"
          label="紧急联系电话"
          placeholder="请输入"
          readonly
        />

        <div class="contract_data">
          <div class="data_idcard">
            <div>身份证</div>
            <div class="idcard_img">
              <div class="img_item">
                <van-image
                  width="100%"
                  fit="fill"
                  :src="detailData.idCard_front"
                />
                <div>正面</div>
              </div>
              <div class="img_item">
                <van-image
                  width="100%"
                  fit="fill"
                  :src="detailData.idCard_back"
                />
                <div>反面</div>
              </div>
            </div>
          </div>

          <van-form>
            <van-cell-group>
              <van-field
                input-align="right"
                :value="detailData.idCard"
                label="身份证号码"
                placeholder="请输入"
                is-link
                readonly
              />

              <div class="data_idcard">
                <div class="m-b20">营业执照</div>
                <van-image
                  width="100%"
                  fit="fill"
                  :src="detailData.businessLicense"
                />
              </div>

              <van-field
                input-align="right"
                :value="detailData.unifiedSocialCreditCode"
                label="统一社会信用代码"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_official"
                label="公司名称"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_legalPerson"
                label="法人姓名"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.company_address"
                label="地址"
                placeholder="请输入"
                is-link
                readonly
              />

              <div class="data_idcard">
                <div class="m-b20">合同文件</div>

                <van-swipe
                  class="my-swipe"
                  :autoplay="1000"
                  indicator-color="black"
                >
                  <van-swipe-item
                    v-for="items in detailData.contractImageList"
                    :key="items"
                  >
                    <van-image width="100%" fit="fill" :src="items.url" />
                  </van-swipe-item>
                </van-swipe>
              </div>

              <van-field
                input-align="right"
                :value="detailData.signTime"
                label="签约日期"
                placeholder="请输入"
                is-link
                readonly
              />

              <van-field
                input-align="right"
                :value="detailData.expirationTime"
                label="到期日期"
                placeholder="请输入"
                is-link
                readonly
              />
            </van-cell-group>
          </van-form>
        </div>
      </van-cell-group>
    </van-form>
  </div>
</template>

<script>
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Form,
  Field,
  CellGroup,
  RadioGroup,
  Radio,
  Tag,
  Swipe,
  SwipeItem,
} from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tag.name]: Tag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      phone: "",
      sms: "",
      password: "",
      radio: "1",
      extra: [
        "商注册",
        "刻章服务",
        "银行开户",
        "税局登记",
        "年审服芳",
        "开户预约",
        "税局上门预约",
      ],
      detailData: [],
    };
  },

  created() {
    this.customerManagementDetail(this.$route.query.id);
  },

  methods: {
    customerManagementDetail(id) {
      var that = this;
      that.$api
        .customerManagementDetailAPI({ id: id })
        .then(function (res) {
          if (res.data.code === 200) {
            that.detailData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error", err);
        });
    },

    //返回上一页
    goback() {
      this.$router.go(-1);
    },

    //客户编辑
    toClientEdit(id) {
      this.$router.push({ path: "/place/clientEdit", query: { id: id } });
    },
  },
};
</script>

<style lang="less" scoped>
.client_detail {
  .detail_list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    position: relative;

    .list_detail {
      display: flex;
      flex-direction: column;
      font-size: 13px;
      align-items: center;

      div {
        margin-top: 5px;
        &:nth-child(1) {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }

    .list_edit {
      position: absolute;
      top: 20px;
      right: 25px;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #3894ff;
      border-bottom: 1px solid #3894ff;
    }
  }

  .lease_title {
    font-size: 14px;
    padding: 10px;
    background: #b9b9b9;
    text-align: center;
  }

  .lease_mark {
    font-size: 14px;
    color: #666;
    padding: 0px 20px;
    background: #fff;
  }

  .van-radio-group {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .van-button {
    height: 35px;
  }

  .contract_data {
    .data_idcard {
      padding: 25px 16px;
      color: #323233;
      font-size: 15px;

      .idcard_img {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;

        .img_item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          width: 48%;
          font-size: 13px;

          div {
            margin-top: 5px;
          }
        }

        .img_license {
          border-radius: 2px;
          background-color: rgba(0, 0, 0, 0.02);
          width: 100%;
          border: 1px solid rgba(0, 0, 0, 0.15);
          height: 150px;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
      }
    }
  }

  /deep/ .van-field__control {
    color: #979797;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/place/clientDetail.vue